import { LineChart, AnnularPie } from 'components'
import validatorMixin from '@/mixins/validator-mixin.js' // 引入mixin文件
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import {getRecordByName} from '@/utils/public.js'
import {getOneWeekBeginAndEndDate, getYear, getMonth, getLastMonth, getDayOfMonth, getYestoday, getLastMonthDays} from '@/utils/date'
import {getRegionList, getSystemSettingList} from '@/api/get-data.js'

const pieColor = ['#41CF87', '#FFA03A', '#FFF06E', '#FF6B6B', '#664CEB', '#4CA2EB', '#4CCFEB', '#4CEBD3', '#8E41CF', '#7FB80e']
const pieTitle = { text: '类型占比', left: '28%', top: '45%' }
const pieLegend = { orient: 'vertical', top: '16%', right: '4%', itemGap: 45 }

export default {
  name: 'SystemSummary',
  data () {
    return {
      rootRegion: null,
      // 接入情况
      stationRegionCount: 0, // 站点数
      streamNodeCount: 0, // 视频节点数
      enviromentNodeCount: 0, // 环境节点数
      powerNodeCount: 0, // 动力节点数
      deviceNodeCount: 0, // 设备节点数
      securityNodeCount: 0, // 安防节点数
      fireNodeCount: 0, // 火灾节点数
      controlNodeCount: 0, // 控制节点数
      // 运行情况
      encoderCount: 0, // 设备接入数
      encoderOfflineCount: 0, // 设备离线数
      todayAlarmTimes: 0, // 今日告警次数
      yesterdayAlarmTimes: 0, // 昨日告警次数
      thisMonthAlarmTimes: 0, // 当月告警次数
      lastMonthAlarmCount: 0, // 上月告警次数
      alarmTimesMonthOnMonth: 1.0, // 月告警次数环比
      strAlarmTimesMonthOnMonth: '0%', // 月告警次数环比
      // 最近告警事件表格数据
      tableData: [],
      tableTotalRow: 0,
      lastEventId: 0,
      // 遮罩层
      loading: false,
      // 查询条件
      eventDates: [],
      eventAlarmFiltered: 1,
      canceledAlarmFiltered: 1,
      confirmedAlarmFiltered: 1,
      deviceErrorAlarmFiltered: 0,
      recordShowMaxDays: 7,
      tableQueryParams: {
        lastEventId: 0,
        regionId: 0,
        objectId: 0,
        descendantRegionRequired: 1,
        resourceKind: 255,
        resourceSubType: 255,
        systemKind: 0,
        beginHappenDateTime: 0,
        endHappenDateTime: 0,
        handleStates: [], // 处理状态数组
        orderBy: 1, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 8
      },
      // 一周告警及设备故障趋势lineChart数据
      weekAlarmTimes: [],
      weekOfflineTimes: [],
      dataLineChartId: 'data-line-chart',
      dataLineChartData: [['', '一天告警次数', '', '一天离线次数']], // xAxis-时间，yAxis-数据节点数值
      dataLineChartColor: ['#FF6B6B', '#FFA03A'],
      // 告警分类数量统计pie数据
      pieId: 'annular-pie',
      pieData: [['类型占比', '无告警'], ['无告警', 0]],
      pieColor: pieColor,
      pieTitle: pieTitle,
      pieLegend: pieLegend,
      pollingTimer: null,
      pollingTimer2: null
    }
  },
  components: {
    LineChart,
    AnnularPie
  },
  mixins: [
    validatorMixin,
    ssoLoginMixin,
    idNameMixin,
    convertorMixin
  ],
  computed: {
  },
  mounted() {
    // 设置查询起始日期和截止日期
    this.eventDates = getOneWeekBeginAndEndDate() // 近一周

    // 读取告警通知设定
    getSystemSettingList(() => {
      let record = getRecordByName('eventAlarmFiltered', this.$globalData.systemSettingList)
      this.eventAlarmFiltered = record ? Number(record.settingValue) : 1
      record = getRecordByName('canceledAlarmFiltered', this.$globalData.systemSettingList)
      this.canceledAlarmFiltered = record ? Number(record.settingValue) : 1
      record = getRecordByName('confirmedAlarmFiltered', this.$globalData.systemSettingList)
      this.confirmedAlarmFiltered = record ? Number(record.settingValue) : 1
      record = getRecordByName('deviceErrorAlarmFiltered', this.$globalData.systemSettingList)
      this.deviceErrorAlarmFiltered = record ? Number(record.settingValue) : 0
      record = getRecordByName('recordShowMaxDays', this.$globalData.systemSettingList)
      this.recordShowMaxDays = record ? Number(record.settingValue) : 7

      // 设置查询起始日期
      this.eventDates[0] = new Date(new Date().getTime() - this.recordShowMaxDays * 24 * 3600 * 1000)
    })

    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        // 获取根区域
        for (let i = 0; i < this.$globalData.regions.length; ++i) {
          if (this.$globalData.regions[i].parentRegionId === 0) {
            this.rootRegion = this.$globalData.regions[i]
            break
          }
        }
        // 查询站端区域数量、系统种类资源数量列表、根区域、根区域告警次数、根区域上月告警次数、根区域离线次数、根区域上月离线次数、根区域各类型事件数量和事件列表
        this.getStationRegionCount().then(res => {
          this.getRootRegion().then(res => {
            this.getRootSystemKindResourceCountList().then(res => {
              this.getRootRegionAlarmTimes().then(res => {
                this.getRootRegionLastMonthAlarmTimes().then(res => {
                  this.getRootRegionOfflineTimes().then(res => {
                    this.getRootRegionLastMonthOfflineTimes().then(res => {
                      this.getRootRegionEventCount().then(res => {
                        this.getEventList()

                        // 更新一周告警及离线趋势曲线
                        this.dataLineChartData = [['', '一天告警次数', '', '一天离线次数']]
                        let recordCount = this.weekAlarmTimes.length > this.weekOfflineTimes.length ? this.weekOfflineTimes.length : this.weekAlarmTimes.length
                        for (let i = recordCount - 1; i >= 0; --i) {
                          this.dataLineChartData.push([new Date(this.weekAlarmTimes[i][0]), this.weekAlarmTimes[i][1],
                            new Date(this.weekOfflineTimes[i][0]), this.weekOfflineTimes[i][1]])
                        }
                        this.$nextTick(() => {
                          if (this.$refs.dataLineChart) {
                            this.$refs.dataLineChart.draw()
                          }
                          if (this.$refs.annularPie) {
                            this.$refs.annularPie.draw()
                          }
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })

      // 开始数据轮巡
      this.startDataPolling()
    })
  },
  beforeDestroy() {
    // 停止数据轮巡
    this.stopDataPolling()
  },
  methods: {
    // 查询站端区域数量
    getStationRegionCount() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$http(this.$api.regionList, {
          regionId: 0,
          parentRegionId: 0,
          regionKind: 41109999, // 电力行业变电站
          pageNum: 1,
          pageSize: 1000,
          totalPage: 0
        }).then(
          res => {
            if (res.code === 200) {
              this.stationRegionCount = res.data.length
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          reject(err)
        })
      })
    },
    // 查询根区域列表
    getRootRegion() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$http(this.$api.regionList, {
          regionId: this.rootRegion ? this.rootRegion.id : 0,
          parentRegionId: 0,
          regionKind: 0,
          pageNum: 1,
          pageSize: 1000,
          totalPage: 0
        }).then(
          res => {
            if (res.code === 200 && res.data.length > 0) {
              this.rootRegion = res.data[0]
              this.encoderCount = this.rootRegion.encoderCount
              this.encoderOfflineCount = this.rootRegion.encoderOfflineCount
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          reject(err)
        })
      })
    },
    // 查询根区域系统种类资源数量列表
    getRootSystemKindResourceCountList() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$http(this.$api.systemKindResourceCountList, {
          systemDictionaryItemId: 0,
          systemDictionaryItemValue: '',
          regionId: this.rootRegion ? this.rootRegion.id : 0,
          pageNum: 1,
          pageSize: 1000,
          totalPage: 0
        }).then(
          res => {
            if (res.code === 200) {
              res.data.forEach(item => {
                if (item.systemDictionaryItemValue === '1100') { // 视频监控
                  this.streamNodeCount = item.streamNodeCount
                } else if (item.systemDictionaryItemValue === '3100') { // 安全防范
                  this.securityNodeCount = item.dataNodeCount + item.controlNodeCount
                } else if (item.systemDictionaryItemValue === '3200') { // 消防系统
                  this.fireNodeCount = item.dataNodeCount + item.controlNodeCount
                } else if (item.systemDictionaryItemValue === '3300') { // 环境监测
                  this.enviromentNodeCount = item.dataNodeCount + item.controlNodeCount
                } else if (item.systemDictionaryItemValue === '3400') { // 动力监测
                  this.powerNodeCount = item.dataNodeCount + item.controlNodeCount
                } else if (item.systemDictionaryItemValue === '3600') { // 设备监测
                  this.deviceNodeCount = item.dataNodeCount + item.controlNodeCount
                } else if (item.systemDictionaryItemValue === '4100') { // 设备控制
                  this.controlNodeCount = item.controlNodeCount
                }
              })
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          reject(err)
        })
      })
    },
    // 查询根区域当月告警次数
    getRootRegionAlarmTimes() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$http(this.$api.regionAlarmTimesStatList, {
          regionId: this.rootRegion ? this.rootRegion.id : 0,
          year: getYear(),
          month: getMonth(),
          pageNum: 1,
          pageSize: 1000,
          totalPage: 0
        }).then(
          res => {
            if (res.code === 200 && res.data.length > 0) {
              let today = getDayOfMonth()
              if (today > 1) { // 今日大于1，否则从上月中找
                this.yesterdayAlarmTimes = res.data[0]['alarmTimes' + getYestoday()] // 昨日告警次数
              }
              this.todayAlarmTimes = res.data[0]['alarmTimes' + today] // 今日告警次数
              this.thisMonthAlarmTimes = res.data[0].monthAlarmTimes // 当月告警次数
              // 汇总本周告警次数
              this.weekAlarmTimes = []
              for (let i = 0; i < 7; ++i) {
                if (today - i <= 0) {
                  break
                }
                let key = 'alarmTimes' + (today - i).toString()
                this.weekAlarmTimes.push([new Date().getTime() - i * 3600 * 24 * 1000, res.data[0][key]])
              }
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          reject(err)
        })
      })
    },
    // 查询根区域上月告警次数
    getRootRegionLastMonthAlarmTimes() {
      let year = getMonth() === 1 ? getYear() - 1 : getYear()
      let lastMonth = getLastMonth()
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$http(this.$api.regionAlarmTimesStatList, {
          regionId: this.rootRegion ? this.rootRegion.id : 0,
          year: year,
          month: lastMonth,
          pageNum: 1,
          pageSize: 1000,
          totalPage: 0
        }).then(
          res => {
            if (res.code === 200 && res.data.length > 0) {
              let today = getDayOfMonth() // 返回当月今日
              if (today === 1) { // 今日等于1，取上月最后一天数值
                this.yesterdayAlarmTimes = res.data[0]['alarmTimes' + getLastMonthDays()] // 昨日告警次数
              }
              this.lastMonthAlarmCount = res.data[0].monthAlarmTimes // 上月告警次数
              // 计算月告警次数环比
              if (this.lastMonthAlarmCount > 0) {
                this.alarmTimesMonthOnMonth = (this.thisMonthAlarmTimes - this.lastMonthAlarmCount) / this.lastMonthAlarmCount
                this.strAlarmTimesMonthOnMonth = this.strValueFromDouble(this.alarmTimesMonthOnMonth * 100, 2) + '%'
                if (this.alarmTimesMonthOnMonth > 0) {
                  this.strAlarmTimesMonthOnMonth = '+' + this.strAlarmTimesMonthOnMonth
                }
              } else {
                this.alarmTimesMonthOnMonth = 0.00
                this.strAlarmTimesMonthOnMonth = '0%'
              }
              // 汇总周告警次数
              let remainDays = 0
              if (today < 7) { // 本月不足一周，以上月天数作为补充
                remainDays = 7 - today
                let date = new Date()
                let lastMonthLastDate = new Date(date.getFullYear(), date.getMonth(), 0) // 获取上月最后一天日期
                for (let i = 0; i < remainDays; ++i) {
                  let key = 'alarmTimes' + (lastMonthLastDate.getDate() - i).toString()
                  this.weekAlarmTimes.push([lastMonthLastDate.getTime() - i * 3600 * 24 * 1000, res.data[0][key]])
                }
              }
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          reject(err)
        })
      })
    },
    // 查询根区域离线次数
    getRootRegionOfflineTimes() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$http(this.$api.regionOfflineTimesStatList, {
          regionId: this.rootRegion ? this.rootRegion.id : 0,
          year: getYear(),
          month: getMonth(),
          pageNum: 1,
          pageSize: 1000,
          totalPage: 0
        }).then(
          res => {
            if (res.code === 200 && res.data.length > 0) {
              let today = getDayOfMonth()
              // 汇总本周离线次数
              this.weekOfflineTimes = []
              for (let i = 0; i < 7; ++i) {
                if (today - i <= 0) {
                  break
                }
                let key = 'offlineTimes' + (today - i).toString()
                this.weekOfflineTimes.push([new Date().getTime() - i * 3600 * 24 * 1000, res.data[0][key]])
              }
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          reject(err)
        })
      })
    },
    // 查询根区域上月离线次数
    getRootRegionLastMonthOfflineTimes() {
      let year = getMonth() === 1 ? getYear() - 1 : getYear()
      let lastMonth = getLastMonth()
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$http(this.$api.regionOfflineTimesStatList, {
          regionId: this.rootRegion ? this.rootRegion.id : 0,
          year: year,
          month: lastMonth,
          pageNum: 1,
          pageSize: 1000,
          totalPage: 0
        }).then(
          res => {
            if (res.code === 200 && res.data.length > 0) {
              let today = getDayOfMonth() // 返回今日
              // 汇总本周离线次数
              let remainDays = 0
              if (today < 7) { // 本月不足一周，以上月天数作为补充
                remainDays = 7 - today
                let date = new Date()
                let lastMonthLastDate = new Date(date.getFullYear(), date.getMonth(), 0) // 获取上月最后一天日期
                for (let i = 0; i < remainDays; ++i) {
                  let key = 'offlineTimes' + (lastMonthLastDate.getDate() - i).toString()
                  this.weekOfflineTimes.push([lastMonthLastDate.getTime() - i * 3600 * 24 * 1000, res.data[0][key]])
                }
              }
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          reject(err)
        })
      })
    },
    // 查询根区域当天各种类型的告警事件数量
    getRootRegionEventCount() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$http(this.$api.regionEventCountStatList, {
          regionId: this.rootRegion ? this.rootRegion.id : 0,
          statDate: Number(new Date().Format('yyyyMMdd')),
          pageNum: 1,
          pageSize: 1000,
          totalPage: 0
        }).then(
          res => {
            if (res.code === 200) {
              if (res.data.length > 0 && res.data[0].eventTypeCount > 0) {
                this.pieData = [['类型占比']]
                for (let i = 1; i <= res.data[0].eventTypeCount; ++i) {
                  let eventTypeName = this.$type.getEventTypeNameById(res.data[0]['resourceKind' + i], res.data[0]['eventType' + i])
                  this.pieData[0].push(eventTypeName)
                  this.pieData.push([eventTypeName, res.data[0]['eventCount' + i]])
                }
              } else {
                this.pieData = [['类型占比', '无告警'], ['无告警', 0]]
              }
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          reject(err)
        })
      })
    },
    // 查询历史事件列表
    getEventList() {
      if (this.lastEventId > 0 &&
        this.lastEventId >= this.$store.getters.appLastEventId) { // 检测是否有新事件
        return
      }

      this.loading = true
      // 查询历史事件列表
      this.tableQueryParams.objectId = 0
      this.tableQueryParams.beginHappenDateTime = this.eventDates[0].getTime() / 1000
      this.tableQueryParams.endHappenDateTime = new Date().getTime() / 1000
      this.tableQueryParams.alarmLevels = this.eventAlarmFiltered ? [1, 2, 3] : []
      // this.tableQueryParams.alarmStates = this.canceledAlarmFiltered ? [1, 2] : []
      // this.tableQueryParams.handleStates = this.confirmedAlarmFiltered ? [0] : []
      this.$http(this.$api.historyEventList, this.tableQueryParams).then(
        res => {
          if (res.code === 200) {
            res.data.forEach(item => { // 更新最大事件id
              if (item.id > this.lastEventId) {
                this.lastEventId = item.id
              }
            })

            /* this.tableData = res.data.filter(item => { // 事件过滤
              if (this.deviceErrorAlarmFiltered && (getResourceOnlineState(item.resourceKind, item.alarmState,
                item.eventType, 0, 0) === 0)) { // 设备故障告警过滤
                return false
              }
              return true
            }) */
            this.tableData = res.data
            this.tableTotalRow = res.page.totalRow
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 分页
    handleCurrentPageChange(val) {
      this.tableQueryParams.pageNum = val
      this.getEventList()
    },
    // 开始数据轮巡
    startDataPolling() {
      this.pollingTimer = setInterval(() => {
        if (this.loading) { // 检测上一次查询是否尚未结束
          return
        }
        this.getEventList()

        // 定时重绘图表
        this.$nextTick(() => {
          if (this.$refs.dataLineChart) {
            this.$refs.dataLineChart.draw()
          }
          if (this.$refs.annularPie) {
            this.$refs.annularPie.draw()
          }
        })
      }, this.$globalConfig.pagePollingInterval)

      this.pollingTimer2 = setInterval(() => {
        if (this.loading) { // 检测上一次查询是否尚未结束
          return
        }

        // 查询站端区域数量、系统种类资源数量列表、根区域、根区域告警次数、根区域上月告警次数、根区域离线次数、根区域上月离线次数、根区域各类型事件数量和事件列表
        this.getStationRegionCount().then(res => {
          this.getRootRegion().then(res => {
            this.getRootSystemKindResourceCountList().then(res => {
              this.getRootRegionAlarmTimes().then(res => {
                this.getRootRegionLastMonthAlarmTimes().then(res => {
                  this.getRootRegionOfflineTimes().then(res => {
                    this.getRootRegionLastMonthOfflineTimes().then(res => {
                      this.getRootRegionEventCount().then(res => {
                        // 更新一周告警及离线趋势曲线
                        this.dataLineChartData = [['', '一天告警次数', '', '一天离线次数']]
                        let recordCount = this.weekAlarmTimes.length > this.weekOfflineTimes.length ? this.weekOfflineTimes.length : this.weekAlarmTimes.length
                        for (let i = recordCount - 1; i >= 0; --i) {
                          this.dataLineChartData.push([new Date(this.weekAlarmTimes[i][0]), this.weekAlarmTimes[i][1],
                            new Date(this.weekOfflineTimes[i][0]), this.weekOfflineTimes[i][1]])
                        }
                        this.$nextTick(() => {
                          if (this.$refs.dataLineChart) {
                            this.$refs.dataLineChart.draw()
                          }
                          if (this.$refs.annularPie) {
                            this.$refs.annularPie.draw()
                          }
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      }, 300 * 1000)
    },
    // 停止数据轮巡
    stopDataPolling() {
      if (this.pollingTimer2 != null) {
        clearInterval(this.pollingTimer2)
        this.pollingTimer2 = null
      }
      if (this.pollingTimer != null) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/home/systemSummary/SystemSummary.js